import { AsphaltMixDesigns } from '../../../cimsPage/instances/materials'
import { CreateViewEditSoftRemoveRestore } from '../../common'

const { Create, Edit, RemoveRestore, View } = CreateViewEditSoftRemoveRestore({
  create: 'd9fe159e-689a-40ca-bbd7-a7636873e77e',
  edit: '20085b03-fccb-421f-8623-f07143ca3878',
  view: '08f9a2d2-73f3-44ca-8f41-acb47ef594cc',
  removeRestore: 'ae00c586-7b20-4f1f-9f22-120e1913ac83',
  object: 'Asphalt Mix Design Target',
  page: AsphaltMixDesigns,
})

export const CreateLIMSAsphaltMixDesignTarget = Create
export const EditLIMSAsphaltMixDesignTarget = Edit
export const RemoveRestoreLIMSAsphaltMixDesignTarget = RemoveRestore
export const ViewLIMSAsphaltMixDesignTarget = View

export type LIMSAsphaltMixDesignTargetPermissionItem =
  | typeof CreateLIMSAsphaltMixDesignTarget
  | typeof EditLIMSAsphaltMixDesignTarget
  | typeof RemoveRestoreLIMSAsphaltMixDesignTarget
  | typeof ViewLIMSAsphaltMixDesignTarget
